<template>
  <div class="container-fluid login">
    <div class="row">
      <div class="col-12 col-md-5 col-lg-5 d-flex align-items-center flex-column info">
        <div class="logo">
          <a :href="lpUrl" class="ico-iouu" target="_blank" title="IOUU"></a>
        </div>
        <div class="row justify-content-center d-flex align-items-center">
          <div class="col-12 col-lg-10 d-flex flex-column align-items-center">
            <h1>Acessar conta</h1>
            <p>
              Não se preocupe. Você não está assumindo nenhum compromisso neste momento.
              <br/>Suas informações serão usadas apenas para analisarmos o seu perfil
            </p>
            <p>
              Através da plataforma, você poderá enviar todos os documentos solicitados, fazer investimentos e solicitar empréstimo.
            </p>
          </div>        
        </div>
        <social-network/>
      </div>
      <div class="col-12 col-md-7 col-lg-7 d-flex flex-column form">
        <header v-if="!this.verifyIE11()"  class="align-self-center align-self-md-end">
          Não tem uma conta?
          <router-link to="criar-conta" class="btn btn-outline-primary">Criar conta</router-link>
        </header>
        <div class="row justify-content-center d-flex align-items-center">

          <!-- ínicio alerta internet exploerer  -->
          <div v-if="this.verifyIE11()" class="col-12 col-md-8 col-lg-6 text-center browser-alert" >
              <h3>Melhore sua experiência</h3>
              <p>Você está usando um navegador da Web que não suportamos.<br>
              Experimente uma destas opções para ter uma melhor experiência na IOUU.</p>
              <ul>
                <li>
                  <a href="https://www.mozilla.org/pt-BR/firefox/download/" target="_blank" title="Baixar última versão Mozilla Firefox">
                    <img src="/static/assets/images/browser/firefox.png" alt="Ícone Mozilla Firefox">
                    <span>Mozila Firefox</span>
                  </a>
                </li>
                <li>
                  <a href="https://www.google.com/chrome/" target="_blank"  title="Baixar última versão Google Chrome">
                    <img src="/static/assets/images/browser/google-chrome.png" alt="Ícone Google Chrome">
                    <span>Google Chrome</span>
                  </a>
                </li>
                 <li>
                  <a href="https://www.microsoft.com/pt-br/windows/microsoft-edge" target="_blank"  title="Baixar última versão Microsoft Edge">
                    <img src="/static/assets/images/browser/edge.png" alt="Ícone Edge">
                    <span>Microsoft Edge</span>
                  </a>
                </li>
              </ul>
          </div>
          <!-- final alerta internet explorer -->

          <div v-if="!this.verifyIE11()" class="col-12 col-md-8 col-lg-5 text-center">
            <h2><span class="greeting">{{greeting}} :)</span>Acesse sua conta</h2>
            <div class="btn-group btn-group-justified align-self-center " role="group" aria-label="Large button group">
              <button id="fb-signin-button" @click="facebookLogin" class="btn btn-lg btn-secondary facebook"><span><i class="fab fa-facebook-f"></i> Facebook</span></button>
              <button id="gg-signin-button" class="btn btn-lg btn-secondary google"><span><i class="fab fa-google"></i> Google</span></button>
              <!-- <button id="lk-signin-button" @click="linkedinLogin" class="btn btn-lg btn-secondary linkedin"><span><i class="fab fa-linkedin-in"></i> Linkedin</span></button> -->
              <!-- <button @click="linkedinLogin" class="btn btn-lg btn-secondary linkedin"><span><i class="fab fa-linkedin-in"></i> Linkedin</span></button> -->
              
            </div>
            <!--<span class="other">ou</span> -->
            <form @submit.prevent="login">
              <div class="form-group text-left">
                <label for="inputEmail">Endereço de email</label>
                <input id="inputEmail" type="email" class="form-control form-control-lg" v-model="email" autofocus>
              </div>
              <div class="form-group text-left">
                <div class="password-field-container">
                  <label for="inputPassword" class="float-left">Senha</label>
                  <small class="form-text text-muted float-right"> <router-link to="recuperar-senha" title="Esqueceu sua senha?" tabindex="-1">Esqueceu sua senha?</router-link></small>
                </div>
                <password-field v-model="password"/>
              </div>
              <div class="form-check text-left d-flex justify-content-left">
                <div class="checkboxContainer">
                  <input class="form-check-input" type="checkbox" v-model="keepLogged">
                  <span class="checkmark"></span>
                </div>
                <label class="form-check-label p-0">
                  Permanecer conectado
                </label>
              </div>
              <button id="buttonLogin" class="btn btn-lg btn-primary">Entrar</button>
            </form>
          </div>
        </div>
      </div>      
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../assets/styles/iouu/_variables";
  @import "../assets/styles/iouu/_mixins";

	.browser-alert {

		h3 {
			@include font-size(30px);
			padding-bottom: 20px;
		}

		p {
			color: #666;
		}

		ul {
			list-style: none;
			margin:0px;
			padding:0px;
			display:flex;
			justify-content: center;
			li {
				display: inline;
				padding:10px;
				img {
					width: 70px;
					margin-bottom: 5px;
				}
				span {
					display: block;
				}
				a {
					&:hover {
						span {
							color: #333;
						}
					}
				}
			}
		}

		@include xs {
			h3 {
				@include font-size(20px);
			}

			ul {
				li {
					img {
						width: 50px;
					}
					span {
						font-size: 12px;
					}
				}
			}
		}

		@include ds {
			h3 {
				@include font-size(25px);
			}
			p {
				@include font-size(12px);
			}
			ul {
				li {
					img {
						width: 60px;
					}
					span {
						font-size: 13px;
					}
				}
			}
		}		
	}

  .form-check-label {
    &.p-0 {
      & {
        padding-left: 0;
      }
    }
  }

  // CHECKBOX - CUSTOM 
	.checkboxContainer {
		&{
		  display: block;
		  position: relative;
		  cursor: pointer;
		  -webkit-user-select: none;
		  -moz-user-select: none;
		  -ms-user-select: none;
			user-select: none;
			width: 25px;
			height: 25px;
			margin-right: 10px;
    }
    
		&:hover {
		  input ~ .checkmark {
			background-color: #ccc;
		  }
		}
	
		input {
		  position: absolute !important;
		  opacity: 0;
		  width: 25px;
		  height: 25px;
		  cursor: pointer;
			left: 0;
      margin-left: 0;
      top: -4px;
	
		  &:checked ~ .checkmark {
			background-color: #41D3BF;
		  }
		}
	
		.checkmark {
		  position: absolute;
		  top: -4px;
		  left: 0;
		  height: 25px;
		  width: 25px;
		  background-color: #eee;
		  border-radius: 6px;
		  cursor: pointer;
		  pointer-events: none;
	
		  &::after {
			content: "";
			position: absolute;
			display: none;
			left: 9px;
			top: 5px;
			width: 8px;
			height: 13px;
			border: solid white;
			border-width: 0 3px 3px 0;
			-webkit-transform: rotate(45deg);
			-ms-transform: rotate(45deg);
			transform: rotate(45deg);
		  }
	
		}
	
		input:checked ~ .checkmark:after {
		  display: block;
		}
	}
	// END CHECKBOX - CUSTOM

  .login {
    .info {
      background:url(/static/assets/images/bg-login.jpg) top center no-repeat, linear-gradient(to bottom right, $c3, $c2 85%);
      background-size: cover;
      // background-blend-mode: multiply;
      text-align: center;
      color: #fff;
    }
  }

  .greeting {
    color: #95989A;
    display: block;
  }
  .password-field-container {
    display: inline-block;
    width: 100%;
  }

  @include brkp-01(991px) {
    .login {
      .form {
        flex: 0 0 100%;
        max-width: 100%;
      }
    }
  }
</style>
<script src="https://apis.google.com/js/platform.js?onload=renderButton"></script>
<script>
import ApiClient from '../utils/api-client'
import ApiClientGo from '../utils/api-client-go'
import SocialNetwork from '../components/SocialNetwork'
import ArrayHelper from '@/utils/array-helper'
import PasswordField from '@/components/PasswordField'
import * as mutationTypes from '@/store/mutation-types.js'
import SessionManager from '@/utils/session-manager'

import VueAnalytics from 'vue-analytics'

export default {
  data() {
    return {
      lpUrl: process.env.LP_URL,
      email: '',
      password: '',
      keepLogged: false,
      // User: {},
      // TipoUser: '',
      // suitability: '',
      // investidor: '',
      // investimentos: ''
    }
  },
  components: {
    SocialNetwork, PasswordField
  },
  computed: {
    isLoggedIn() { return this.$store.state.isLoggedIn },
    greeting() {
      const currentHours = new Date().getHours()
      if(currentHours < 12) {
        return "Bom dia"
      } else if(currentHours < 18) {
        return "Boa tarde"
      } else {
        return "Boa noite"
      }
    }
  },
  async created() {

    this.fbLoadSDK(document, 'script', 'facebook-jssdk')
    this.ggLoadSDK(document, 'script', 'google-jssdk')
    setTimeout(() => { 
      this.fbStartServices()
      this.ggStartServices()
    }, 3000);

    // this.User = this.$store.state.currentUser

    this.$store.commit(mutationTypes.STOP_LOADING);
  },
  methods: {
    googleLogin() {

      const scope = this;

      this.$gAuth.signIn()
      .then(GoogleUser => {

        scope.$store.dispatch('socialNetworkLogin', { 
          provider:'google', 
          receivedData: GoogleUser.Zi.access_token, 
          errorMessage: scope.$Notify.error
        })

      })
      .catch(error  => {
        console.log('Sign-in error', error);
      })
    },
    fbLoadSDK(d, s, id){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    },
    ggLoadSDK(d, s, id){
      var js, fjs = document.getElementsByTagName(s)[0];
      if (document.getElementById(id)) return;
      js = document.createElement(s); js.id = id;
      js.src = "https://apis.google.com/js/platform.js?onload=renderButton";
      fjs.parentNode.insertBefore(js, fjs);
    },
    fbStartServices(){
      FB.init({
        appId      : process.env.FB_ID,
        cookie     : true,
        xfbml      : true,
        version    : 'v4.0'
      });
    },
    ggStartServices(){
      let scope = this
      gapi.load('auth2', function() {
        gapi.auth2.init({
          client_id: process.env.GG_ID,
          cookiepolicy: 'single_host_origin',
          scope: 'profile'
        }).attachClickHandler(document.getElementById('gg-signin-button'), {},
          (googleUser) => {
            scope.$store.dispatch('socialNetworkLogin', {provider:'google', receivedData:googleUser.getAuthResponse().id_token, errorMessage: scope.$Notify.error})
          },
          (error) => {
            console.log('Sign-in error', error);
          }
        );
      });
    },
    facebookLogin(e) {
      e.preventDefault()
      let scope = this
      FB.login(function(response) {
        if (response.status === 'connected') {
          scope.$store.dispatch('socialNetworkLogin', {provider:'facebook', receivedData:response.authResponse.accessToken, errorMessage: scope.$Notify.error})
        } else {
          console.log("Não Loggado")
        }
      }, {scope: 'public_profile,email'});
    },
    login() {

      this.email = this.email.toLowerCase().trim()
      
      this.$store.dispatch('login', {email: this.email, password: this.password, keepLogged: this.keepLogged})
        .then((resp) => {
          var urlParams = '';
          // var now = new Date();
          sessionStorage.removeItem("redirectINV")

          this.$ga.set({userId: this.email})
          
          for (var key in this.$route.query) {
            if (this.$route.query.hasOwnProperty(key)) { 
              if(key == "redirected_from") 
                urlParams = this.$route.query[key];      
              else
                urlParams = urlParams + "&" + key + "=" + this.$route.query[key];      
            }
          }

          if(this.$route.query.loansId !== undefined && this.$route.query.loansId !== "" && this.$route.query.loadnId !== null){
            this.$router.push(`/informacoes-adicionais/emprestimo-coletivo/${this.$route.query.loansId}`)	
          } else	if(urlParams != ''){
            this.$router.push(urlParams);
          } else {
            this.$router.push("/"); 
          }
        })
        .catch(error => {
          if(error.response.data.Msg){
            this.$Notify.error(error.response.data.Msg)
          }else{
            this.$Notify.error("Tivemos um erro inesperado, tente novamente mais tarde")
            // const errorMessages = error.response.data.errors.map(error => error.detail)
            // this.$Notify.error(ArrayHelper.toSentence(errorMessages))
          }
        })
    },
    verifyIE11()
    {
      return (!(window.ActiveXObject) && "ActiveXObject" in window);
    },
    //tagueamento GA
    taggingGA() {
      this.$ga.page({
        page: '/login',
        title: 'Login',
      })
    },
  },
  async created() {
    //tagueamento GA
    await this.taggingGA();
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Login.vue